import React from "react"
import profile from "../images/profile2.png"
import { useSpring, animated } from 'react-spring'
import { Link } from "gatsby"
import {
  faGithub,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"


const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
const trans4 = (x, y) => `translate3d(${x / 5.5}px,${y / 5.5}px,0)`

export const About = () => {
  const [props, set] = useSpring(() => ({ xy: [0, 0], config: { mass: 10, tension: 550, friction: 140 } }))

  return (
    <div className="container mx-auto justify-center mt-12 " id="about">
      <h2 className=" text-center mx-auto underline sm:text-4xl text-3xl font-bold title-font ">About Me</h2>
      <div className="grid grid-cols-1 md:grid-cols-2">
      
        <div className="max-h-96 md:h-screen w-screen mt-14 " onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })}>
            <animated.img
              src={profile}
              width="320px"
              height="320px"
              className="rounded-circle sm:ml-3 lg:ml-28 lg:mt-8 xl:ml-28 xl:mt-8  shadow-inner"
              alt="hero"
              style={{ transform: props.xy.interpolate(trans4) }}
            />
        </div>
        
        <div className="flex lg:mt-0 p-10  ">
          <div className="mb-auto mt-auto max-w-lg">
            <h1 className="text-3xl uppercase">Ganesh Pandey</h1>
            <p className="font-semibold mb-4">Software Engineer||AI Enthusiast</p>
            <p>
             I'm a passionate software engineer with 3 years of experience at Hitachi Systems India.
             I specialize in Python, Django, Node.js, AI/ML, NLU, and NLP, with a basic understanding of cloud technologies like AWS and Azure.
             I thrive on solving complicated issues and constructing scalable solutions.
             My function often involves coding and participating with go-purposeful groups to make certain that we supply excellent, robust products.
                  
                  My experience with cloud systems like AWS and Azure has equipped me with the competencies to deploy 
                  and control packages efficiently, making sure they're reliable and scalable. 
                    
                    Outside of work, I revel in chess, and travelling, which helps me stay innovative and balanced. <br/>
                    Feel free to connect with me on                       <Link to="https://www.linkedin.com/in/ganesh-pandey-1426b4171/" target="_blank">
                        
                        <FontAwesomeIcon
                          icon={faLinkedin}
                          size="lg"
                          role="button"
                          aria-label="LinkedIn"
                        />
                      </Link> to talk about ability collaborations or opportunities. I stay up for connecting!
            </p>
            <a className="main-btn hover:no-underline align-content-end justify-content-end  text-sm" href="https://drive.google.com/file/d/1tIwlUDg1lhdBgRyxZIX_ddKYb7Ocd0x1/view?usp=sharing" download target="blank">Download Resume</a>
          </div>
       
        </div>
   
      </div>

    </div>
  )
}
